module.exports = __webpack_public_path__ + "static/img/c10.221f7af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customer/c10.png
// module id = rq8e
// module chunks = 0